/* Optional funnel bridge for an existing analytics installation.
   No new trackers, cookies, requests, guest details or booking payloads.
   Events reach an existing dataLayer only after Shopify analytics consent.
   A checkout request is deliberately not counted as a purchase. */
(() => {
  'use strict';
  if (!document.body.classList.contains('by-hospitality') || window.bookYorkMeasurementLoaded) return;
  window.bookYorkMeasurementLoaded = true;
  const canMeasure = () => {
    try { return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true; }
    catch (_) { return false; }
  };
  const send = (event, root, extra = {}) => {
    if (!root || !canMeasure() || !Array.isArray(window.dataLayer)) return;
    window.dataLayer.push({ event, property_id: String(root.dataset.propertyId || ''), ...extra });
  };
  const viewed = new WeakSet();
  const viewProperties = () => document.querySelectorAll('[data-book-york-booking]').forEach(root => {
    if (!viewed.has(root) && canMeasure() && Array.isArray(window.dataLayer)) {
      viewed.add(root);
      send('bookyork_property_viewed', root);
    }
  });
  document.addEventListener('visitorConsentCollected', viewProperties);
  document.addEventListener('shopify:section:load', viewProperties);
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const root = event.target.closest('[data-book-york-booking]');
    if (!root) return;
    if (event.target.closest('[data-open-calendar]')) send('bookyork_dates_opened', root);
    const continueButton = event.target.closest('[data-booking-continue]');
    if (continueButton && !continueButton.disabled && !root.querySelector('[data-booking-quote]')?.hidden) {
      const ready = ['first', 'last', 'email'].every(key => root.querySelector(`[data-guest-${key}]`)?.value.trim());
      if (ready) send('bookyork_checkout_requested', root);
    }
  }, true);
  document.addEventListener('bookyork:booking-quote', event => {
    const root = event.target.closest('[data-book-york-booking]');
    const { quote = {}, payload = {} } = event.detail || {};
    const total = Number(quote.total);
    const adults = Number(payload.adults), children = Number(payload.children);
    const extra = {};
    if (Number.isFinite(total)) extra.value = total;
    if (/^[A-Z]{3}$/.test(quote.currency || 'GBP')) extra.currency = quote.currency || 'GBP';
    if (Number.isFinite(adults) && Number.isFinite(children)) extra.guests = adults + children;
    send('bookyork_quote_returned', root, extra);
  });
  viewProperties();
})();
